import { get } from 'lodash';

export default function shouldHideData(data) {
  return !get(data, 'permissions.can_view.authorization', false);
}
